export default "__VITE_ASSET__34641036__"